import * as React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ArrowRight from '../../../icons/ArrowRight'
const BoxWrapper = styled.div `
    height: 35px;
    background: #005daa -webkit-gradient(linear, left top, left bottom, color-stop(0.88, #004379), color-stop(0, #075ca1));
    background: #005daa -webkit-linear-gradient(top, #075ca1 0%, #004379 88%);
    background: #005daa -moz-linear-gradient(top, #075ca1 0%, #004379 88%);
    background: #005daa -o-linear-gradient(top, #075ca1 0%, #004379 88%);
    background: #005daa -ms-linear-gradient(top, #075ca1 0%, #004379 88%);
    background: #005daa linear-gradient(to bottom, #075ca1 0%, #004379 88%);
    border-left: #0679d7 solid 6px;
    display: flex;
    & ::before {
        content: "";
        margin-left: 2px;
        border-left: #0679d7 solid 2px;
        height: 100%;
        display: inline-block;
      }
    & .titles {
        display: flex;
        flex-direction: column;
        position: relative;
        right: -10px;
        padding: 0;
        margin: 0;
        flex-grow: 2;
        & .header-title {
            color: #d8e3f8;
            display: inline-block;
            font-weight: 700;
            padding-top: 1px;
          }
        & .header-sub-title {
            color: #d8e3f8;
            display: inline-block;
            padding: 0;
            margin: -4px 0 0 0;
            font-size: 0.6em;
          }
      }
`;
const HeaderLink = styled.a `
    width: 108px;
    height: 20px;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: inset 5px 5px 5px #ccc;
    -moz-box-shadow: inset 5px 5px 5px #ccc;
    -webkit-box-shadow: inset 5px 5px 5px #ccc;
    -o-box-shadow: inset 5px 5px 5px #ccc;
    font-size: 8px;
    font-weight: 700;
    text-decoration: none;
    color: #004379;
    padding: 2px 6px;
    margin: auto 6px;
    display: flex;
    align-items: center;
      & :hover {
        background-color: #dedede;
      }
`
const BoxHeader = (props: {linkHeader: boolean, link: string, title: string, subTitle: string, linkTitle: string})=>{
    const {linkHeader, link, title, subTitle, linkTitle} = props
    const subwin = (fn: string, bana: string, w: number, h: number) => {
        const  wx = w;
        const  wy = h;
       
        const  x = (screen.width - wx) / 2;
        const  y = (screen.height - wy) / 2;
         window.open(fn, bana, "toolbar=no,location=no,directories=no,scrollbars=yes,resizable=yes,left=" + x + ",top=" + y + ",width=" + wx + ",height=" + wy);
       }
    return (
        <BoxWrapper>
        <div className="titles">
          <span className="header-title">{title}</span>
          <span className="header-sub-title">{subTitle}</span>
        </div>
        { linkHeader && (
        <HeaderLink href="#" onClick={() => subwin(`${link}`,'0123',850,800)}><ArrowRight></ArrowRight>{linkTitle}</HeaderLink>
        )}
      </BoxWrapper>
    )
}

BoxHeader.defaultProps = {
    linkHeader: true,
    link: '',
    title: '',
    subTitle: '',
    linkTitle: ''
  };

  BoxHeader.propTypes = {
    linkHeader: PropTypes.bool,
    link: PropTypes.string,
    subTitle: PropTypes.string,
    title: PropTypes.string,
    linkTitle: PropTypes.string
  }

export default BoxHeader